import { useMemo } from "react";

import { User } from "../models/user";
import { StateEnveloped } from "../redux/helpers";
import { makeHookDeprecationWarn } from "../helpers/warnings";
import { useUserData, useUpdateUser } from "../next/hooks";
import { useUserGlobalActivity, useUserGlobalStatus } from "../next/hooks/user";

export type UserHookResult = StateEnveloped<User> & {
  modifiers: {
    updateUser: (user: User) => Promise<User>;
  };
};
export type UserHook = () => UserHookResult;

const deprecationWarn = makeHookDeprecationWarn("useUser");

/**
 * @deprecated Use next.hooks.useUser instead.
 */
const Hook: UserHook = () => {
  deprecationWarn();

  const data = useUserData();
  const { mutate: updateUser } = useUpdateUser();
  const status = useUserGlobalStatus();
  const activity = useUserGlobalActivity();

  const modifiers = useMemo(() => ({ updateUser }), [updateUser]);

  const memoizedResult = useMemo(
    () => ({
      status,
      activity,
      data,
      modifiers,
    }),
    [status, activity, data, modifiers],
  );

  return memoizedResult;
};

export default Hook;
